import { contactDataManagement as base } from './base';
import { contactDataManagement as AT } from './AT';
import { contactDataManagement as HR } from './HR';
import { contactDataManagement as HU } from './HU';
import { contactDataManagement as SK } from './SK';
import { contactDataManagement as RO } from './RO';
import { contactDataManagement as CZ } from './CZ';
import { contactDataManagement as RS } from './RS';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
